import { render, staticRenderFns } from "./QuickSelection.vue?vue&type=template&id=05b9cd64&"
import script from "./QuickSelection.vue?vue&type=script&lang=js&"
export * from "./QuickSelection.vue?vue&type=script&lang=js&"
import style0 from "./QuickSelection.vue?vue&type=style&index=0&id=05b9cd64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports